// removed by extract-text-webpack-plugin
module.exports = {"checkbox":"_3Ce88BD6Aei8Jc3qD-8VWy","checkmark":"_3ulnPOcJjSfdvKXEHCk7sH","input":"_2FfoDhDuOnN08N7ocUp7US","label":"_2ZUhvj56jHpx6XYdZmTFip","checked":"_2lK9nIE9uxNG9_y1-GKEwh","spin":"_1fIfHHnQWGGhKTDbaKTBop"};


//////////////////
// WEBPACK FOOTER
// ./src/public/components/Input/Checkbox/styles.scss
// module id = 865
// module chunks = 18